import { render } from "./BookUnitItem.vue?vue&type=template&id=754739ac&scoped=true"
import script from "./BookUnitItem.vue?vue&type=script&lang=js"
export * from "./BookUnitItem.vue?vue&type=script&lang=js"

import "./BookUnitItem.vue?vue&type=style&index=0&id=754739ac&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754739ac"]])

export default __exports__